import l from '../../../../lang';
import TopDashboardSection from '../../../common/top-dashboard-section';
import Card from '../../../common/card';
import CreatedOpenPaymentLink from '../created/open-link';

const OpenPaymentLinkPage = () => (
  <div className="created_payment_links">
    <TopDashboardSection
      title={l('menu.subItem.OPEN_PAYMENT_LINK')}
      subtitle={l('openPaymentLink.page.subheadline')}
    />
    <Card>
      <CreatedOpenPaymentLink />
    </Card>
  </div>
);

export default OpenPaymentLinkPage;
